import { Button } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react';
import PropTypes from 'prop-types';

const useStyles = makeStyles({
  btnContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 35,
    marginBottom: 10
  },
  btnStyle: {
    width: '45%',
    borderRadius: '20px'
  }
});

export default function ChooseOldPaper({ handleBack }) {
  const classes = useStyles();
  return (
    <div style={{ marginTop: 15 }}>
      choose old paper
      <div className={classes.btnContainer}>
        <Button variant="outlined" onClick={() => handleBack()} className={classes.btnStyle}>
          Back
        </Button>
        <Button variant="contained" color="primary" onClick={() => {}} className={classes.btnStyle}>
          Next
        </Button>
      </div>
    </div>
  );
}

ChooseOldPaper.propTypes = {
  handleBack: PropTypes.func
};
